// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"325":"f24aed18","328":"ceecb235"}[chunkId] + ".chunk.css";
};